export function stringValueToBoolean(val?: string | boolean) {
  if (typeof val === 'boolean') {
    return val;
  }
  if (typeof val === 'string') {
    return val?.toLocaleLowerCase() === 'true';
  }
  return false;
}
